module.exports = __webpack_public_path__ + "static/media/7.bc91a7c0.jpeg";